// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2MA-L","box":"WorkspacesBox_box__2wEGW","node":"WorkspacesBox_node__1RdEs"};